<template>
  <div
    class="text-ontick-carbon-900 relative text-sm font-medium dark:text-gray-300"
  >
    <button
      class="dark:border-ontick-carbon-500 border-ontick-steel-200 dark:bg-ontick-graphite-500 bg-ontick-steel-200 flex w-full items-center justify-between rounded border px-3 py-2 shadow-sm focus:outline-none"
      @click="is_options_expanded = !is_options_expanded"
      @blur="is_options_expanded = false"
    >
      <span class="whitespace-no-wrap mr-2 flex items-center">
        <span class="text-ontick-small text-ontick-font-nineth font-medium">{{
          selected.param_name
        }}</span>
        <span
          class="text-ontick-font-nineth text-ontick-small rounded-full px-1 py-0 font-bold"
          >(#{{ selected.param_id }})</span
        >
      </span>
      <svg
        fill="none"
        viewBox="0 0 24 24"
        stroke="#a0aec0"
        class="h-4 w-4 transform transition-transform duration-100 ease-in-out"
        :class="is_options_expanded ? 'rotate-180' : 'rotate-0'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    <transition
      enter-active-class="transform transition duration-300 ease-custom"
      enter-class="-translate-y-1/2 scale-y-0 opacity-0"
      enter-to-class="translate-y-0 scale-y-100 opacity-100"
      leave-active-class="transform transition duration-300 ease-custom"
      leave-class="translate-y-0 scale-y-100 opacity-100"
      leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
    >
      <ul
        v-show="is_options_expanded"
        class="dark:border-ontick-carbon-500 border-ontick-steel-200 dark:bg-ontick-graphite-500 bg-ontick-steel-200 absolute left-0 right-0 z-50 mb-4 overflow-hidden rounded-b border shadow-lg"
        style="z-index: 1000"
      >
        <li
          v-for="(param, index) in parameterSettings"
          :key="index"
          class="cursor-pointer px-3 py-2 backdrop-filter transition-colors duration-100 hover:backdrop-brightness-105"
          @mousedown.prevent="setOption(param)"
        >
          <span class="font-normal">{{ param.param_name }}</span>
          <span
            class="text-ontick-font-nineth text-ontick-small rounded-full px-1 py-0 font-bold"
            >(#{{ param.param_id }})</span
          >
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "modal-select",
  data() {
    return {
      is_options_expanded: false,
      selected: {},
    };
  },
  computed: {
    ...mapState({
      parameterSettings: (state) =>
        state.investment.parameters.parameterSettings,
      selectedParameter: (state) =>
        state.investment.parameters.selectedParameter,
    }),
  },
  created() {
    this.selected = this.selectedParameter;
    this.$emit("change", this.selectedParameter);
  },
  methods: {
    setOption(option) {
      this.selected = option;
      this.$emit("change", option);
      this.is_options_expanded = false;
    },
  },
};
</script>

<style scoped>
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
</style>
